import Vue from 'vue'
import Router from 'vue-router'
import Store from './store/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/passwordReminder',
      name: 'passwordReminder',
      component: () => import('./views/PasswordReminder.vue')
    },
    {
      path: '/passwordReminder/:passwordReminderToken',
      name: 'passwordReminderReissue',
      component: () => import('./views/PasswordReminderReissue.vue')
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: () => import('./views/PrivacyPolicy.vue')
    },
    {
      path: '/termsOfService',
      name: 'termsOfService',
      component: () => import('./views/TermsOfService.vue')
    },
    {
      path: '/passwordChange',
      name: 'passwordChange',
      component: () => import('./views/PasswordChange.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/companySelect',
      name: 'companySelect',
      component: () => import('./views/CompanySelect.vue'),
      meta: { requiresAuth: true, requiresPasswordChange: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/dashboard/Index.vue'),
      meta: { requiresAuth: true, requiresPasswordChange: true },
      children: [
        {
          path: '/dashboard/general',
          name: 'general',
          component: () => import('./views/dashboard/General.vue'),
        },
        {
          path: '/dashboard/co2detail',
          name: 'co2detail',
          component: () => import('./views/dashboard/CarbonDioxideDetail.vue'),
        },
        {
          path: '/dashboard/productAnalysis',
          name: 'productAnalysis',
          component: () => import('./views/dashboard/ProductAnalysis.vue'),
        },
        {
          path: '/dashboard/recycleFlow',
          name: 'recycleFlow',
          component: () => import('./views/dashboard/RecycleFlow.vue'),
        },
      ]
    },
    {
      path: '/dashboardDetail',
      name: 'dashboardDetail',
      component: () => import('./views/dashboardDetail/Index.vue'),
      meta: { requiresAuth: true, requiresPasswordChange: true },
      children: [
        {
          path: '/dashboardDetail/productAnalysisDetail',
          name: 'productAnalysisDetail',
          component: () => import('./views/dashboardDetail/ProductAnalysisDetail.vue')
        },
        {
          path: '/dashboardDetail/productAnalysisDetailForImprovement',
          name: 'productAnalysisDetailForImprovement',
          component: () => import('./views/dashboardDetail/ProductAnalysisDetailForImprovement.vue')
        },
      ]
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('./views/error/Index.vue'),
      children: [
        {
          path: '/error/403',
          name: '403',
          component: () => import('./views/error/403.vue'),
        },
        {
          path: '/error/404',
          name: '404',
          component: () => import('./views/error/404.vue'),
        },
        {
          path: '/error/500',
          name: '500',
          component: () => import('./views/error/500.vue'),
        },
        {
          path: '/error/noContract',
          name: 'noContract',
          component: () => import('./views/error/NoContract.vue'),
        },
      ]
    },
    {
      path: '*',
      redirect: '/error/404',
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('./views/error/Maintenance.vue'),
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})
router.beforeEach((to, from, next) => {
  const isMaintenance = process.env.VUE_APP_MAINTENANCE_FLG === 'on';
  if (isMaintenance) {
    if (to.path !== '/maintenance') {
      next({
        path: '/maintenance'
      });
    } else {
      next();
    }
    return;
  }

  if (!isMaintenance && to.path === '/maintenance') {
    next({
      path: '/error/404'
    });
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // routerでrequiresAuth=trueで設定されているものに関しては、
    // Tokenがない場合やセッションが切れている場合はstore内のapiの401エラーでログイン画面にリダイレクト。
    Store.dispatch("auth/getLoginInfo")
      .then(() => {
        // ログイン済みでセッションが切れていない場合は下記処理を継続
        if (
          to.matched.some(record => record.meta.requiresPasswordChange) &&
          Store.state.auth.loginInfo.isInitialPassword
        ) {
          // 初期パスワード変更が必要な画面且つユーザーが初期パスワードの場合
          next({
            path: '/passwordChange',
            query: {
              redirect: to.fullPath
            }
          });
        } else {
          next();
        }
      })
      .catch(err => {
        console.log(err);
      })
  } else {
    // public系画面はそのまま遷移
    next();
  }
});

export default router
